import { useMemo } from 'react';
import { FormField, Input, InputTypes } from 'taboola-ultimate-ui';
import { useEventValueHandler } from 'hooks';
import { withIndication } from 'modules/errors';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { useFormValidatedValue, validationFunctions } from 'modules/taboola-common-frontend-modules/validations';
import styles from './DuplicateCopiesFields.module.scss';

const validations = [
    {
        validationFn: validationFunctions.range,
        options: { min: 'minCopies', max: 'maxCopies' },
        messageId: 'campaigns.group.editor.duplicate.numberOfCopies.range.error',
        defaultMessage: 'Please enter a number between {minCopies} and {maxCopies}.',
    },
];

const InputWithIndication = withIndication(Input);

export const DuplicateCopiesFields = ({ maxCopies, field }) => {
    const validationDependencies = useMemo(() => ({ data: { minCopies: 1, maxCopies } }), [maxCopies]);

    const {
        value: numberOfCopies,
        onChange: onChangeNumberOfCopies,
        indicationData,
    } = useFormValidatedValue({
        field,
        validations,
        validationDependencies,
    });
    const changeHandler = useEventValueHandler(onChangeNumberOfCopies);

    return (
        <FormField
            inputId="campaigns-group-copies"
            containerClass={styles['input']}
            label={
                <FormattedMessage
                    id="campaigns.group.editor.duplicate.numberOfCopies.label"
                    defaultMessage="Number of Copies"
                />
            }
        >
            <InputWithIndication
                id="numOfCopies"
                type={InputTypes.NUMBER}
                size={Input.SIZE.SMALL}
                value={numberOfCopies ?? ''}
                onChange={changeHandler}
                {...indicationData}
            />
        </FormField>
    );
};
